import admin from './admin';
import columnTypes from '../columnTypes.js';
import types from '../types.js';
import arm from './assetReview.js';
import udm from './udm.js';
import ad from './ActiveDirectory';
import gls from './globalsearch.js';
import ps from './processScheduler.js';
import combinedpam from './combinedPAM.js';

const shared = [
  {
    key: 'user-select-modal-results',
    name: 'User Select Modal Results',
    [columnTypes.default.key]: [
      { source: 'userName', rename: 'AD Name', type: types.text },
      { source: 'domain', rename: 'Domain', type: types.text },
      { source: 'SamAccountName', rename: 'SamAccountName', type: types.text },
      { source: 'Email', rename: 'Email', type: types.text },
    ],
    [columnTypes.extra.key]: [
      { source: 'BusinessUnit', rename: 'Business Unit', type: types.text },
      { source: 'DepartmentName', rename: 'Department Name', type: types.text },
      { source: 'Manager', rename: 'Manager', type: types.text },
    ],
    [columnTypes.hidden.key]: [
      { source: 'STSGuid', rename: 'Account Unique ID', type: types.text },
      { source: 'UID', rename: 'User ID', type: types.number },
    ],
  },
];

export default [
  ...shared,
  ...admin,
  ...arm,
  ...udm,
  ...ad,
  ...gls,
  ...ps,
  ...combinedpam,
];
